import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';




import {ApiMessageService} from '../../core/api-message.service';
import {TipoEntitaLocale} from './tipoentitalocale.model';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';

@Injectable()
export class TipoEntitaLocaleService extends CommonService<TipoEntitaLocale> {

  public static ROUTE = 'tipoentitalocale';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): TipoEntitaLocale {
    return JsonBaseBuilder.jsonToTipoEntitaLocale(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return TipoEntitaLocaleService.ROUTE;
  }

  public existingDescr(descr: string, entity: TipoEntitaLocale): Observable<boolean> {
    return this.getBoolean('/existingdescr', new HttpParams()
      .set('descr', descr)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public getTable(items: TipoEntitaLocale[]): Table {
    return Table.buildBaseTable(TipoEntitaLocale.getTableKeys(), items);
  }


}
